const SCROLL_EDGE_THRESHOLD = 1;

type DiscoverRowScrollMetrics = {
  clientWidth: number;
  scrollWidth: number;
  scrollLeft: number;
};

type DiscoverRowScrollAvailability = {
  canScrollPrevious: boolean;
  canScrollNext: boolean;
};

const readDiscoverRowScrollAvailability = ({ clientWidth, scrollWidth, scrollLeft }: DiscoverRowScrollMetrics): DiscoverRowScrollAvailability => {
  const maxScrollLeft = Math.max(scrollWidth - clientWidth, 0);

  return {
    canScrollPrevious: scrollLeft > SCROLL_EDGE_THRESHOLD,
    canScrollNext: scrollLeft < maxScrollLeft - SCROLL_EDGE_THRESHOLD,
  };
};

export default readDiscoverRowScrollAvailability;
